// extracted by mini-css-extract-plugin
export default {"trustedRetailerBanner":"JX-z","trustedRetailerTooltipWrapper":"KX-z"};